import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";

export default function HomeWhatOurCustomerSays() {
    return (
        <>

            <section className="eq-feedback-section ptb-120">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-6 col-lg-9">
                            <div className="section-title ps-sm-3 text-center text-lg-start">
                                <h5 className="mb-2 text-eq-primary">Excelência em Atendimento</h5>
                                <h2 className="mb-3">Os Nossos Clientes Satisfeitos</h2>
                                <p className="mb-0">Está em nosso DNA dar o melhor atendimento aos nossos clientes, gerando a melhor experiência de compra de veículos do mercado.</p>
                            </div>
                        </div>
                    </div>
                    <div className="py-5 px-sm-3">
                        <Swiper
                            speed={1000}
                            loop={true}
                            autoplay={true}
                            slidesPerView={3}
                            spaceBetween={24}
                            pagination={{
                                el: ".eq-feedback-pagination",
                                type: "bullets",
                                clickable: true
                            }}
                            breakpoints={{
                                [0]: { slidesPerView: 1 },
                                [768]: { slidesPerView: 2 },
                                [1200]: { slidesPerView: 3 }
                            }}
                            modules={[Pagination, Autoplay]}                           
                        >
                            <SwiperSlide className="swiper-slide bg-white rounded overflow-hidden">
                            <div className="customerSaysDiv">
                            <img src="../img/Clientes6.jpeg" className="customerSays"/>
                            </div>
                            </SwiperSlide>
                            <SwiperSlide className="swiper-slide bg-white rounded overflow-hidden">
                            <div className="customerSaysDiv">
                            <img src="../img/Clientes5.jpeg" className="customerSays"/>
                            </div>
                            </SwiperSlide>
                            <SwiperSlide className="swiper-slide bg-white rounded overflow-hidden">
                            <div className="customerSaysDiv">
                            <img src="../img/Clientes4.jpeg" className="customerSays"/>
                            </div>
                            </SwiperSlide>
                            <SwiperSlide className="swiper-slide bg-white rounded overflow-hidden">
                            <div className="customerSaysDiv">
                            <img src="../img/Clientes3.jpeg" className="customerSays"/>
                            </div>
                            </SwiperSlide>
                            <SwiperSlide className="swiper-slide bg-white rounded overflow-hidden">
                            <div className="customerSaysDiv">
                            <img src="../img/Clientes2.jpeg" className="customerSays"/>
                            </div>
                            </SwiperSlide>
                            <SwiperSlide className="swiper-slide bg-white rounded overflow-hidden">
                            <div className="customerSaysDiv">
                            <img src="../img/Clientes1.jpeg" className="customerSays"/>
                            </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </section>

        </>
    );
}